module.exports = {
          srcSet: __webpack_public_path__ + "916d2d33160c7e07e62e338d7f13de1b-167.png"+" 167w",
          images:[ {path: __webpack_public_path__ + "916d2d33160c7e07e62e338d7f13de1b-167.png",width: 167,height: 167}],
          src: __webpack_public_path__ + "916d2d33160c7e07e62e338d7f13de1b-167.png",
          toString:function(){return __webpack_public_path__ + "916d2d33160c7e07e62e338d7f13de1b-167.png"},
          
          width: 167,
          height: 167
        }